import { createAction, createAsyncAction } from 'typesafe-actions'

export const callOrderComplete = createAction('CMD / OrderComplete / call')<void>()

export const callOrderCompleteAsync = createAsyncAction(
    'EVT / OrderComplete / call request',
    'EVT / OrderComplete / call success',
    'EVT / OrderComplete / call failure',
)<undefined, void, Error>()
